<template>
  <div>
    <div class="row align-items-stratch">
      <div class="col-3 my-3">
        <button
          @click="onFileChange"
          class="btn border border-3 rounded border-secondary w-100 d-flex justify-content-center align-items-center"
          :style="{
            borderStyle: 'dashed !important',
          }"
        >
          <img
            v-show="imageUrl"
            :src="imageUrl"
            alt=""
            id="imagePreview"
            class="w-100 h-100"
          />
          <div v-show="!imageUrl" id="imagePreview">
            <p>Importer ici l'image de votre catégorie.</p>
          </div>
        </button>
      </div>

      <div class="col-9 row">
        <div class="col">
          <label for="">Nom</label>
          <input type="text" v-model="section.fullName" class="form-control" />
        </div>
        <div class="col-3">
          <label for="">Dépôt <span class="text-danger">*</span> </label>
          <select v-model="section.deposit_reference" class="form-select">
            <option
              v-for="(deposit, index) in deposits"
              :key="index++"
              :value="deposit.reference"
            >
              {{ deposit.fullName }}
            </option>
          </select>
        </div>

        <div class="col-3">
          <label for="">Fournisseur <span class="text-danger">*</span> </label>
          <select v-model="section.supplier_reference" class="form-select">
            <option value=""></option>
            <option
              v-for="(supplier, index) in suppliers"
              :key="index++"
              :value="supplier.reference"
            >
              {{ supplier.society }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row mt-3 justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(section)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      section: {},
      file: null,
      imageUrl: "",
    };
  },
  computed: {
    ...mapGetters("supplier", {
      suppliers: "getAll",
    }),
    ...mapGetters("deposit", {
      deposits: "getAll",
    }),
  },
  methods: {
    async save(data) {
      let formData = new FormData();

      formData.append("image", this.file);
      formData.append("fullName", data.fullName);
      formData.append("description", data.description);

      await this.$store.dispatch("section/store", formData);
      // await this.$store.dispatch("section/store", data);
      // await this.$store.dispatch("section/store", data);
    },
    async refresh() {
      this.$store.dispatch("supplier/getAll");
      this.$store.dispatch("deposit/getAll");
    },
    async onFileChange(event) {
      // this.file = event.target.files[0];
      const input = document.createElement("input");
      input.type = "file";
      input.style.display = "none";

      input.addEventListener("change", (event) => {
        this.file = event.target.files[0];

        // Show the image
        this.imageUrl = URL.createObjectURL(this.file);
      });

      document.body.appendChild(input);
      input.click();
      document.body.removeChild(input);
      // Show the image
      this.imageUrl = URL.createObjectURL(this.file);
    },
  },
  beforeMount() {
    this.$store.dispatch("supplier/getAll");
    this.$store.dispatch("deposit/getAll");
  },
};
</script>
